<template>
  <PageContentDocument
    :page-data="pageData"
    :page-data-default-locale="pageDataDefaultLocale"
  />
</template>

<script setup>
import { queryPagePrivacyPolicyDetail } from '../../data-layer/queries'

const { setTheme } = useTheme()
const { screen } = useScreen()
const route = useRoute()
const { useAsyncDataWithQuery, onAfterAdyenData, onBeforeAdyenData, localeGlobalContentData, labels } =
  useMainPageData()
const { getSlug, getSlugParent } = usePageUtils()
const slug = getSlug(route.path) || ''
const slugParent = getSlugParent(route.path) || 'privacy-policy'
const { defaultLocale } = useLocales()
const { locale: localeRef } = useI18n()

await onBeforeAdyenData({ globalDataContentType: 'PagePrivacyPolicyDetail', withRoutes: true })

const { data } = await useAsyncData('privacy-policy-detail-' + slug + '-' + localeRef.value, async () => {
  const page = await useAsyncDataWithQuery(queryPagePrivacyPolicyDetail, {
    variables: {
      withParent: true,
      slugParent
    }
  })

  let pageDataDefaultLocale = null
  const pageId = page.pageData.sysId

  if (page.pageData.content.defaultLocaleFallbackEnabled) {
    try {
      pageDataDefaultLocale = await useAsyncDataWithQuery(queryPagePrivacyPolicyDetail, {
        locale: defaultLocale,
        variables: { withParent: true, slugParent, sysId: pageId }
      })
    } catch (e) {
      console.error(`>>> pageDataDefaultLocale failed for ${slug} in ${localeRef.value} `, e.message)
    }
  }

  return {
    pageData: page.pageData,
    pageDataDefaultLocale
  }
})

const pageData = computed(() => {
  return data.value?.pageData
})

const pageDataDefaultLocale = computed(() => {
  return data.value?.pageDataDefaultLocale?.pageData
})

setTheme('light')

await onAfterAdyenData(data.value)
</script>
